import React from "react";
import Svg, { Path } from "react-native-svg";
import theme from "app/Theme/Theme";

const MessageIcon = ({ width, height, color, style }) => {
  return (
    <Svg
      style={style}
      width={width}
      height={height}
      viewBox="0 0 12 10"
      preserveAspectRatio="xMidYMin meet"
    >
      <Path
        d="M11.3057 10.0035C11.5701 10.0035 11.7992 9.91626 11.9939 9.7439L8.6619 6.41179C8.58196 6.46903 8.50448 6.5247 8.43128 6.57763C8.18193 6.76134 7.97955 6.9047 7.82415 7.00743C7.66877 7.11039 7.46204 7.21533 7.20398 7.32248C6.94574 7.42975 6.70517 7.48322 6.482 7.48322H6.47546H6.46893C6.24573 7.48322 6.00516 7.42977 5.74695 7.32248C5.48873 7.21533 5.282 7.11039 5.12677 7.00743C4.97139 6.9047 4.76912 6.76136 4.51964 6.57763C4.45012 6.52666 4.37302 6.47074 4.28966 6.41089L0.957031 9.7439C1.15174 9.91626 1.38096 10.0035 1.6453 10.0035H11.3057Z"
        fill="white"
      />
      <Path
        d="M1.25765 4.31347C1.00832 4.14725 0.787217 3.95687 0.594727 3.74243V8.81198L3.53153 5.87517C2.944 5.465 2.187 4.94503 1.25765 4.31347Z"
        fill="white"
      />
      <Path
        d="M11.6993 4.31347C10.8054 4.91851 10.0456 5.43938 9.41992 5.87635L12.3555 8.8121V3.74243C12.1673 3.95256 11.9486 4.14281 11.6993 4.31347Z"
        fill="white"
      />
      <Path
        d="M11.3051 0.762817H1.64472C1.3077 0.762817 1.04859 0.876624 0.867074 1.104C0.685409 1.33149 0.594727 1.61599 0.594727 1.95717C0.594727 2.23277 0.715068 2.53138 0.955643 2.85309C1.19622 3.17468 1.45221 3.42727 1.72349 3.61101C1.87221 3.71608 2.32069 4.02787 3.06893 4.54626C3.47285 4.82616 3.82412 5.07013 4.12597 5.28066C4.38327 5.45994 4.60516 5.61519 4.78836 5.74403C4.80939 5.75878 4.84247 5.78244 4.88637 5.81383C4.93366 5.8478 4.99351 5.89091 5.06735 5.94423C5.20953 6.04706 5.32765 6.13018 5.42173 6.19368C5.51568 6.25721 5.62951 6.32816 5.76305 6.40695C5.89648 6.48563 6.02233 6.5448 6.14045 6.58415C6.25859 6.62348 6.36795 6.64321 6.46856 6.64321H6.4751H6.48163C6.58222 6.64321 6.69161 6.62348 6.80977 6.58415C6.92787 6.5448 7.05361 6.48576 7.18715 6.40695C7.32056 6.32816 7.43424 6.25706 7.52849 6.19368C7.62257 6.13018 7.74069 6.04708 7.88289 5.94423C7.95658 5.89091 8.01643 5.84778 8.06372 5.81393C8.10764 5.78242 8.1407 5.75891 8.16186 5.74403C8.30458 5.64472 8.52698 5.49011 8.826 5.28248C9.37009 4.90444 10.1714 4.34802 11.2333 3.61101C11.5526 3.38794 11.8195 3.11875 12.0339 2.80383C12.248 2.48891 12.3553 2.15857 12.3553 1.81292C12.3553 1.52413 12.2512 1.27702 12.0436 1.07121C11.8357 0.86565 11.5895 0.762817 11.3051 0.762817Z"
        fill="white"
      />
    </Svg>
  );
};

MessageIcon.defaultProps = {
  height: 10,
  width: 12,
  color: theme.colors["neutral.white"],
};

export default MessageIcon;
